import { shallowEqual, useSelector } from "react-redux";
import isMobile from "../utils/common";
import { getEntryAccuracy } from "../utils/locationLock";
import useCleverTap from "./useCleverTap";
import useGA4 from "./useGA4";
import eventBuffer from "./cdp/useCdp";

const initializedTools = {};
/**
 *
 * @returns
 */
const useAnalytics = () => {
  const { init: initCT, trackEventCleverTap: trackEventCT, onUserLogin } = useCleverTap();
  const { init: initGA4, trackEvent: trackEventGA4 } = useGA4();
  const { isLoggedIn, userId } = useSelector(
    (state) => ({
      isLoggedIn: state?.fus?.loginDetail?.loggedin,
      userId: state?.loginSignUp?.userDetails?.emailID || "",
    }),
    shallowEqual,
  );

  /**
   *
   * @param {*} eventName
   * @param {*} properties
   * @param {*} tools
   */
  const init = (tools = ["clevertap", "ga4"]) => {
    if (tools.includes("clevertap") && !initializedTools.clevertap) {
      initCT();
      initializedTools.clevertap = true;
    }
    if (tools.includes("ga4") && !initializedTools.ga4) {
      initGA4();
      initializedTools.ga4 = true;
    }
  };

  /**
   *
   * @param {*} eventName
   * @param {*} properties
   * @param {*} tools
   */
  const trackEvent = (eventName, properties = {}, tools = ["clevertap", "ga4", "CDP"]) => {
    const fetchCleverTapID = window?.clevertap?.getCleverTapID() || null;
    const gateLocationAccuracy = getEntryAccuracy();
    const updatedProperties = {
      ...properties,
      webVersion: "v2",
      ctid: fetchCleverTapID,
      login_status: properties?.login_status || isLoggedIn,
      platform: isMobile() ? "mobile" : "desktop",
    };
    if (gateLocationAccuracy) {
      updatedProperties.gate_location_accuracy = gateLocationAccuracy;
    } else {
      delete updatedProperties.gate_location_accuracy;
    }
    if (tools.includes("clevertap")) {
      trackEventCT(eventName, updatedProperties);
    }
    if (tools.includes("ga4")) {
      trackEventGA4(eventName, properties);
    }
    if (tools.includes("CDP")) {
      eventBuffer.track({ event_name: eventName, user_id: properties?.user_id || userId, ...properties });
    }
  };

  return { init, trackEvent, onUserLogin };
};

export default useAnalytics;
